export default "__VITE_PUBLIC_ASSET__42a71ab5__"